import StarComponent from "./StarComponent";

const WatchButtonComponent = () => {
    return (
        <div className="watch-button gray-bg gray-border">
            <StarComponent />
        </div>
    )
}

export default WatchButtonComponent;